import { render, staticRenderFns } from "./Actas.vue?vue&type=template&id=5304a8cf"
import script from "./Actas.vue?vue&type=script&lang=js"
export * from "./Actas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5304a8cf')) {
      api.createRecord('5304a8cf', component.options)
    } else {
      api.reload('5304a8cf', component.options)
    }
    module.hot.accept("./Actas.vue?vue&type=template&id=5304a8cf", function () {
      api.rerender('5304a8cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/Actas.vue"
export default component.exports